/**
 * Creates annotations for jsgraph that allows to display the result of peak picking.
 * @param peaks - Array of peaks with wavenumber, transmittance, absorbance, kind.
 * @param options - Display options for the annotations.
 * @returns Array of annotation objects for jsgraph.
 */
export function getAnnotations(peaks, options = {}) {
    const { fillColor = 'green', strokeColor = 'red', creationFct, mode = 't100', } = options;
    const annotations = peaks.map((peak) => {
        const annotation = {
            line: 1,
            type: 'rect',
            strokeColor,
            strokeWidth: 0,
            fillColor,
        };
        if (creationFct) {
            creationFct(annotation, peak);
        }
        switch (mode) {
            case 'a':
                annotationAbsorbance(annotation, peak, options);
                break;
            case 't':
                annotationTransmittance(annotation, peak, 1, options);
                break;
            case 't100':
                annotationTransmittance(annotation, peak, 100, options);
                break;
            default:
        }
        return annotation;
    });
    return annotations;
}
function annotationTransmittance(annotation, peak, factor = 1, options = {}) {
    const { showKind = true, showAssignment = true } = options;
    const labels = [];
    let line = 0;
    if (showKind) {
        labels.push({
            text: peak.kind,
            size: '18px',
            anchor: 'middle',
            color: 'red',
            position: {
                x: peak.wavenumber,
                y: peak.transmittance * factor,
                dy: `${23 + line * 14}px`,
            },
        });
        line++;
    }
    if (showAssignment) {
        labels.push({
            text: peak.assignment ?? '',
            size: '18px',
            anchor: 'middle',
            color: 'darkred',
            position: {
                x: peak.wavenumber,
                y: peak.transmittance * factor,
                dy: `${23 + line * 14}px`,
            },
        });
        line++;
    }
    annotation.labels = labels;
    annotation.position = [
        {
            x: peak.wavenumber,
            y: peak.transmittance * factor,
            dy: '10px',
            dx: '-1px',
        },
        {
            x: peak.wavenumber,
            y: peak.transmittance * factor,
            dy: '5px',
            dx: '1px',
        },
    ];
}
function annotationAbsorbance(annotation, peak, options = {}) {
    const { showKind = true, showAssignment = true, assignmentAngle = -45, } = options;
    const labels = [];
    let line = 0;
    if (showKind) {
        labels.push({
            text: peak.kind,
            size: '18px',
            anchor: 'middle',
            color: 'red',
            position: {
                x: peak.wavenumber,
                y: peak.absorbance,
                dy: `${-15 - line * 14}px`,
            },
        });
        line++;
    }
    if (showAssignment) {
        labels.push({
            text: peak.assignment ?? '',
            size: '18px',
            angle: assignmentAngle,
            anchor: 'left',
            color: 'darkred',
            position: {
                x: peak.wavenumber,
                y: peak.absorbance,
                dy: `${-15 - line * 14}px`,
            },
        });
        line++;
    }
    annotation.labels = labels;
    annotation.position = [
        {
            x: peak.wavenumber,
            y: peak.absorbance,
            dy: '-10px',
            dx: '-1px',
        },
        {
            x: peak.wavenumber,
            y: peak.absorbance,
            dy: '-5px',
            dx: '1px',
        },
    ];
}
//# sourceMappingURL=getAnnotations.js.map